/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';
import { useStyles } from './styles';

import { useAppStore } from '../../../store/models/app/index';

function ContentContainer (props) {
    const {
        children = {},
        viewAnimation = {},
        ...others
    } = props;

    const appStore = useAppStore();
    const [isPreview, setIsPreview] = useState(appStore.isPreview);
    const [directLinkLogo, setDirectLinkLogo] = useState(appStore.directLinkLogo || null);
  
    const classes = useStyles({
        viewAnimation,
        isPreview,
    });

    useEffect(() => {
        if (appStore.directLinkLogo) {
            setDirectLinkLogo(appStore.directLinkLogo);
            setIsPreview(appStore.isPreview);
        }
    }, [appStore.observed.directLinkLogo]);
    
    function renderDirectLinkLogo () {
        if (directLinkLogo) {
            return (<Grid className={classNames([classes.logoSpace, 'ecal-directlink-page-logo'])}>
                    <img
                        className={classes.logo}
                        src={directLinkLogo}
                        alt={'Publishers Logo'}
                    />
                </Grid>);
        }
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <Grid
            id='content'
            className={classes.contentContainer}
            {...others}
        >
            { renderDirectLinkLogo() }
            { children }
        </Grid>
    );
}

ContentContainer.propTypes = {
    content: PropTypes.any,
    viewAnimation: PropTypes.bool,
};

export default observer(ContentContainer);